import React from 'react'
import { map } from 'lodash'
import amexImg from '../images/amex.png'
import discoverImg from '../images/discover.png'
import mastercardImg from '../images/mastercard.png'
import visaImg from '../images/visa.png'
import './style.css'

const paymentsMap = {
  amex: amexImg,
  discover: discoverImg,
  mastercard: mastercardImg,
  visa: visaImg,
}

export default function AcceptedPayments(props) {
  return (
    <div className="we-accept">
      {props.field}
      <div className="accepted-cards">
        { map(paymentsMap, (paymentImg, paymentName) => (
          <img alt={paymentName} src={paymentImg} role="presentation" key={paymentName}/>
        ))}
      </div>
    </div>
  )
}